import createLucideIcon from '../createLucideIcon';
import type { LucideIconNode, LucideIconData } from '../types';

export const __iconData: LucideIconData = {
  name: 'hockey-stick',
  size: 24,
  node: [
    ['path', { d: 'M11 4v4c0 1.1-2.025 2-4.5 2S2 9.1 2 8V4', key: 'lexbbr' }],
    [
      'path',
      {
        d: 'M18.21 3.106a2 2 0 013.579 1.789l-6.895 13.789A6 6 0 019.529 22H4.5a1 1 0 010-5h5.528a2 2 0 001.788-1.105z',
        key: '9gk7j2',
      },
    ],
    ['path', { d: 'm18.59 11.295-3.578-1.789', key: '12onxe' }],
    ['path', { d: 'm20.79 6.895-3.578-1.789', key: '11qs8n' }],
    ['path', { d: 'M7 17v5', key: '1yj1jh' }],
    ['ellipse', { cx: '6.5', cy: '4', rx: '4.5', ry: '2', key: 'u5t2ln' }],
  ],
};

/**
 * @deprecated Access `__iconData` instead.
 */
export const __iconNode: LucideIconNode[] = __iconData.node;

/**
 * @component @name HockeyStick
 * @description Lucide SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNMTEgNHY0YzAgMS4xLTIuMDI1IDItNC41IDJTMiA5LjEgMiA4VjQiIC8+CiAgPHBhdGggZD0iTTE4LjIxIDMuMTA2YTIgMiAwIDAxMy41NzkgMS43ODlsLTYuODk1IDEzLjc4OUE2IDYgMCAwMTkuNTI5IDIySDQuNWExIDEgMCAwMTAtNWg1LjUyOGEyIDIgMCAwMDEuNzg4LTEuMTA1eiIgLz4KICA8cGF0aCBkPSJtMTguNTkgMTEuMjk1LTMuNTc4LTEuNzg5IiAvPgogIDxwYXRoIGQ9Im0yMC43OSA2Ljg5NS0zLjU3OC0xLjc4OSIgLz4KICA8cGF0aCBkPSJNNyAxN3Y1IiAvPgogIDxlbGxpcHNlIGN4PSI2LjUiIGN5PSI0IiByeD0iNC41IiByeT0iMiIgLz4KPC9zdmc+Cg==) - https://lucide.dev/icons/hockey-stick
 * @see https://lucide.dev/guide/packages/lucide-react - Documentation
 *
 * @param {Object} props - Lucide icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const HockeyStick = createLucideIcon(__iconData);

export default HockeyStick;
